<script setup>
import useAuth from '../../../store/auth.store'
import { setCssVar, useQuasar } from 'quasar'
import SettingsChangePassword from './SettingsChangePassword.vue'
import {
  useAppI18n,
  SUPPORTED_LOCALES,
  setI18nLanguage,
  loadLocaleMessages
} from '../../../i18n'
import { ref, computed, watch } from 'vue'

const auth = useAuth()
const $quasar = useQuasar()

const toggleDark = (value) => {
  $quasar.dark.set(value)
  if ($quasar.dark.isActive) {
    setCssVar('accent', '#1E1E1E')
  } else {
    setCssVar('accent', '#EEEEEE')
  }
}

function logout () {
  // AuthUtil.logout()
  auth.logout()
}

function changePassword () {
  $quasar.dialog({ component: SettingsChangePassword })
}

const { t, locale } = useAppI18n()

const i18n = async (locale) => {
  console.log(locale)
  await loadLocaleMessages(locale)
  console.log('locale load success')
  setI18nLanguage(locale)
}

const localeOption = ref({
  value: locale.value,
  label: t(`settings.locales.${locale.value}`),
})

watch(localeOption, (option) => {
  setLocale(option)
})

const setLocale = (option) => {
  localeOption.value = option
  i18n(option.value)
}

const LOCALE_OPTIONS = computed(() => SUPPORTED_LOCALES.map((locale) => ({
  value: locale,
  label: t(`settings.locales.${locale}`),
})))
</script>

<template lang='pug'>
.settings
  .flex.q-pa-md
    div.q-pa-md(style="width: 50%; min-width: 300px;")
      .q-pa-md.rounded-borders(:class=`$q.dark.isActive ? 'bg-grey-9' : 'bg-grey-2'` )
        .text-h6.text-bold {{ $t('settings.user.title') }}
        .text-h8 {{ $t('settings.user.name') }}: {{ auth.user.value.name }}
        .text-h8 {{ $t('settings.user.email') }}: {{ auth.user.value.email }}
    div.q-pa-md(style="width: 50%; min-width: 300px;")
      q-list.rounded-borders(separator dense :class=`$q.dark.isActive ? 'bg-grey-9' : 'bg-grey-2'`)
        q-item(tag='label')
          q-item-section
            q-item-label
              .text-bold {{ $t('settings.theme.toggle') }}
          q-item-section(avatar)
            q-toggle(
              color='primary'
              @update:model-value='toggleDark'
              v-model='$q.dark.isActive'
            )
      q-list.rounded-borders.q-my-md(separator dense :class=`$q.dark.isActive ? 'bg-grey-9' : 'bg-grey-2'`)
        q-item(tag='label')
          q-item-section
            q-item-label
              .text-bold {{ $t('settings.language.picker') }}
          q-item-section
            q-select(
              v-model="localeOption"
              :options="LOCALE_OPTIONS"
              :label="$t('settings.language.picker')"
            )
      .flex.q-my-md
        q-btn.q-my-sm.text-weight-bold(
          :class=`$q.dark.isActive ? '' : ''`
          @click='changePassword'
          unelevated
          icon='password'
          color='primary'
          :label='$t("settings.password.change")'
        )
        q-space
        q-btn.q-my-sm.text-weight-bold(
          :class=`$q.dark.isActive ? '' : ''`
          @click='logout'
          unelevated
          icon='logout'
          color='negative'
          :label='$t("auth.logout")'
        )
</template>